module.exports = __webpack_public_path__ + "static/media/hurricane1.95de285a.jpg";